export enum SettingsEnum {
    ANAMNESISQUESTIONNAIRE = 'ANAMNESISQUESTIONNAIRE',
    LIGHTLANGUAGESTYLE = 'LIGHTLANGUAGESTYLE',
    CUSTOMUSECASE = 'CUSTOMUSECASE',
    COMMENTINGSINGLETYPE = 'COMMENTINGSINGLETYPE',
    BASICMODE = 'BASICMODE'
}

